import {
  MissingTranslationHandler, TranslateCompiler, TranslateLoader, TranslateParser, TranslateService, TranslateStore,
} from '@ngx-translate/core';
import { ContextService } from '../../public-api';

export function InitializeTranslateServiceInModule(
  context: ContextService,
  store: TranslateStore,
  currentLoader: TranslateLoader,
  compiler: TranslateCompiler,
  parser: TranslateParser,
  missingTranslationHandler: MissingTranslationHandler,
  useStore: boolean,
  useDefaulLang: boolean,
  useExtend: boolean,
  defaultLang: string): TranslateService {
  const ts = new TranslateService(
    store,
    currentLoader,
    compiler,
    parser,
    missingTranslationHandler,
    useDefaulLang,
    useStore,
    useExtend,
    defaultLang);

  const userLang = context.instance.userLanguage?.substring(0, 2) ?? 'en';
  ts.setDefaultLang(userLang);

  return ts;
}
